export const AUTH_TRANSLATIONS: Record<string, string> = {
  'Адрес подтверждён. Теперь все почтовые уведомления LOVO будут доступны.': 'Your email is confirmed. You can now receive all LOVO email notifications.',
  'Аккаунт с этой почтой уже есть. Войдите по паролю, чтобы безопасно привязать Яндекс ID.': 'An account with this email already exists. Log in with your password to link Yandex ID securely.',
  'Аккаунт с этой почтой уже есть. Войдите по паролю, чтобы безопасно привязать VK ID.': 'An account with this email already exists. Log in with your password to link VK ID securely.',
  'Аккаунт создан. Мы отправили письмо для подтверждения email — можно продолжать работу.': 'Your account has been created. We sent an email confirmation link, and you can continue using LOVO.',
  'Будем присылать SMS об активных перевозках': 'We will send SMS updates about active transports',
  'Ваше имя': 'Your name',
  'Ваше имя (контактного лица)': 'Contact person name',
  'Введите код из SMS': 'Enter the SMS code',
  'Введите корректный email.': 'Enter a valid email address.',
  'Введите пароль.': 'Enter your password.',
  'Введите шестизначный код.': 'Enter the six-digit code.',
  'Неверный код или срок его действия истёк.': 'Invalid or expired SMS code.',
  'Неверный код или срок его действия истёк': 'Invalid or expired SMS code.',
  'Введите email.': 'Enter your email address.',
  'Введите email аккаунта. Мы отправим ссылку для создания нового пароля.': 'Enter your account email. We will send you a link to create a new password.',
  'Введите email. Если аккаунт уже есть — попросим пароль. Если нет — за пару минут создадим, потом верификация и поехали.': 'Enter your email. If an account already exists, we will ask for the password. Otherwise, you can create one in a few minutes and continue to verification.',
  'Вернуться ко входу': 'Back to login',
  'В аккаунте нет выбранного профиля заказчика или перевозчика.': 'This account has no selected customer or carrier profile.',
  'Восстановить пароль': 'Reset password',
  'Входим…': 'Logging in…',
  'Вход через Яндекс пока не настроен.': 'Yandex login is not configured yet.',
  'Вход через VK ID пока не настроен.': 'VK ID login is not configured yet.',
  'Вы отменили вход через Яндекс.': 'You cancelled Yandex login.',
  'Вы отменили вход через VK ID.': 'You cancelled VK ID login.',
  'Выберите роль и введите данные аккаунта': 'Choose your role and enter your account details',
  'Выберите роль, чтобы продолжить': 'Choose a role to continue',
  'Выполняю рейсы и беру заказы': 'I transport pets and accept requests',
  'Готовы возить — начнём': 'Ready to carry pets? Let’s get started',
  'Готово! Добро пожаловать в LOVO': 'All set! Welcome to LOVO',
  'готово': 'done',
  'Документы и доп. данные можно заполнить позже в профиле': 'You can add documents and other details later in your profile',
  'Документы, автомобиль и портфолио загрузите на следующем шаге — без них нельзя откликаться': 'Upload your documents, vehicle and portfolio at the next step. They are required to send offers.',
  'Дорога к месту назначения': 'Road to the destination',
  'Заказчик или перевозчик?': 'Customer or carrier?',
  'Заполните контактные данные и телефон.': 'Enter your contact details and phone number.',
  'Ищу перевозчика для питомца': 'I am looking for a pet carrier',
  'Имя контактного лица': 'Contact person name',
  'Индивидуальный предприниматель. Понадобится ИНН и реквизиты.': 'Sole proprietor. Tax and payment details will be required.',
  'ИНН, ОГРН и реквизиты загрузите в профиле после регистрации': 'Add your tax, registration and payment details in your profile after registration',
  'ИП': 'Sole proprietor',
  'ИП / Компания · одно дополнительное поле — название организации': 'Sole proprietor / Company · one additional field for the organisation name',
  'Компания': 'Company',
  'Компания · одно дополнительное поле — название организации': 'Company · one additional field for the organisation name',
  'контакты': 'contact details',
  'Кто вы?': 'Who are you?',
  'Латиница, цифры, минимум одна заглавная буква': 'Latin letters, numbers and at least one uppercase letter',
  'Минимум 8 символов': 'At least 8 characters',
  'Название компании': 'Company name',
  'Название компании или ИП': 'Company or sole proprietor name',
  'На главную': 'Home',
  'Например, Питомник «Бэсти»': 'For example, Bestie Kennel',
  'Не нашли письмо? Проверьте папку «Спам» или запросите новую ссылку.': 'Cannot find the email? Check your spam folder or request a new link.',
  'Не пришёл код? Отправить снова': 'No code? Send again',
  'Не удалось выполнить действие': 'The action could not be completed',
  'Не удалось войти через Яндекс. Попробуйте ещё раз.': 'Could not log in with Yandex. Please try again.',
  'Не удалось войти через VK ID. Попробуйте ещё раз.': 'Could not log in with VK ID. Please try again.',
  'Не удалось открыть хранилище фото': 'Could not open photo storage',
  'Не удалось отправить код.': 'Could not send the code.',
  'Не удалось проверить email': 'Could not verify the email address',
  'Не удалось создать аккаунт': 'Could not create the account',
  'Неверный email или пароль': 'Incorrect email or password',
  'Неверный код.': 'Incorrect code.',
  'Нет аккаунта?': 'No account yet?',
  'Новый пароль': 'New password',
  'Новый пароль сохранён. Теперь используйте его для входа в LOVO.': 'Your new password has been saved. Use it to log in to LOVO.',
  'Оформить заявку': 'Create a request',
  'обработкой персональных данных': 'personal data processing policy',
  'От этого зависит налоговая схема и поля профиля': 'This determines your tax setup and profile fields',
  'Отправить ещё раз': 'Send again',
  'Отправляем…': 'Sending…',
  'Отправили на': 'Sent to',
  '. Подтверждаем телефон — email подтвердите потом в профиле.': '. We are confirming your phone now; confirm your email later in your profile.',
  '. Подтверждаем телефон сейчас — email подтвердите потом в профиле.': '. We are confirming your phone now; confirm your email later in your profile.',
  'офертой перевозчика': 'carrier terms',
  'Пароли не совпадают.': 'Passwords do not match.',
  'Пароль': 'Password',
  'пароль': 'password',
  'парол': 'password',
  'Пароль изменён': 'Password changed',
  'Пароль: минимум 8 символов, одна заглавная буква и одна цифра.': 'Password must contain at least 8 characters, one uppercase letter and one number.',
  'Передаём перевозчику только после того, как вы примете отклик': 'Shared with the carrier only after you accept an offer',
  'Перейти в кабинет': 'Go to account',
  'Питомник, приют, зооклиника или другая организация': 'Kennel, shelter, veterinary clinic or another organisation',
  'Повторите': 'Repeat',
  'Повторите пароль': 'Repeat password',
  'Подтверждаем email': 'Confirming email',
  'подтверждение телефона': 'phone confirmation',
  'Получить новую ссылку': 'Get a new link',
  'Получить ссылку': 'Get link',
  'Понадобится для входа с других устройств': 'Required to log in from other devices',
  'Придумайте новый пароль для входа в LOVO.': 'Create a new password for logging in to LOVO.',
  'Придумайте пароль': 'Create a password',
  'Проверьте почту': 'Check your email',
  'Проверяем ссылку': 'Checking the link',
  'Проверяем ссылку. Это займёт несколько секунд.': 'Checking the link. This will take a few seconds.',
  'Проверяем…': 'Checking…',
  'Продолжая, вы соглашаетесь с': 'By continuing, you agree to the',
  'Продолжая, вы соглашаетесь с условиями оферты и обработкой персональных данных': 'By continuing, you agree to the terms of service and the personal data processing policy',
  'Регистрируетесь как:': 'Registering as:',
  'Реквизиты и документы организации можно загрузить позже в профиле': 'You can upload company details and documents later in your profile',
  'Расскажите о компании': 'Tell us about your company',
  'Расскажите о себе': 'Tell us about yourself',
  'Самозанятый или физлицо без статуса. Чек формирует платформа.': 'Self-employed or an individual without business status. The platform generates the receipt.',
  'С таким email': 'with this email',
  'с таким email': 'with this email',
  'Аккаунта с email': 'No account exists for',
  '📧 Аккаунта с email': '📧 No account exists for',
  'ещё нет — создадим новый': 'we will create one',
  'Регистрация (': 'Registration (',
  '✓ Телефон подтверждён:': '✓ Phone confirmed:',
  '✓ Телефон подтверждён': '✓ Phone confirmed',
  'Телефон подтверждён': 'Phone verified',
  'После создания аккаунта отправим подтверждение на': 'We will send a confirmation after account creation to',
  'Если аккаунт': 'If an account',
  'существует, письмо со ссылкой уже отправлено.': 'exists, an email with the link has already been sent.',
  'Email подтвердите потом в личном кабинете': 'Confirm your email later in your account',
  'Сессия входа через Яндекс устарела. Попробуйте ещё раз.': 'The Yandex login session has expired. Please try again.',
  'Сессия входа через VK ID устарела. Попробуйте ещё раз.': 'The VK ID login session has expired. Please try again.',
  'Скрыть пароль': 'Hide password',
  'Сменить номер телефона': 'Change phone number',
  'Создать аккаунт': 'Create account',
  'Сохранить новый пароль': 'Save new password',
  'Сохраняем…': 'Saving…',
  'Срок действия ссылки истёк или она уже была использована.': 'The link has expired or has already been used.',
  'Срок действия ссылки истёк или она уже была использована. Запросите новую.': 'The link has expired or has already been used. Request a new one.',
  'Ссылка действует 30 минут': 'The link is valid for 30 minutes',
  'Ссылка не работает': 'The link does not work',
  'Телефон': 'Phone',
  'тип аккаунта': 'account type',
  'Тип перевозчика': 'Carrier type',
  'условиями оферты': 'terms of service',
  'У аккаунта нет профиля заказчика.': 'This account has no customer profile.',
  'У аккаунта нет профиля перевозчика.': 'This account has no carrier profile.',
  'Фамилия': 'Last name',
  'Хотите найти перевозчика — начнём': 'Looking for a carrier? Let’s get started',
  'Частное лицо': 'Individual',
  'Частное лицо · имя видят заказчики, телефон — только после принятия отклика': 'Individual · customers can see your name; your phone number is shared only after an offer is accepted',
  'Частное лицо · имя нужно перевозчику для связи, телефон — для оперативных уведомлений': 'Individual · your name helps the carrier contact you, while your phone is used for urgent updates',
  'Частное лицо · имя нужно перевозчику для связи, телефон — для оперативных уведомлений': 'Individual · your name helps the carrier contact you, while your phone is used for urgent updates',
  'Это определит, какие поля будут в профиле': 'This determines which fields appear in your profile',
  'Это займёт несколько секунд.': 'This will take a few seconds.',
  'Email подтверждён': 'Email confirmed',
  'Юридическое лицо. Понадобятся реквизиты организации.': 'Legal entity. Company details will be required.',
  'Я владелец животного и хочу его перевезти': 'I own a pet and need transport',
  'Яндекс': 'Yandex',
  'Заказчик': 'Customer',
  'Забыли пароль?': 'Forgot password?',
  'профил': 'profile',
  'ООО/ИП “ХХХ”': 'LLC / Sole proprietor “XXX”',
  'VK ID не передал email. Разрешите доступ к почте и попробуйте ещё раз.': 'VK ID did not provide an email address. Allow email access and try again.',
  'или войти через': 'or log in with',
  'и': 'and',
};
